import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import type { RouteObject } from "react-router-dom";

const hsaFunnelMerchantBreadcrumb = breadcrumbSlot();

export const paymentsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Payments" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        path: "hsa",
        handle: { breadcrumb: "HSA" },
        children: [
          {
            path: "payment-analytics",
            handle: { breadcrumb: "Payment analytics" },
            async lazy() {
              const { HsaPaymentAnalyticsPage } =
                await import("../conversion/hsa-payment-analytics-page");
              return { Component: HsaPaymentAnalyticsPage };
            },
          },
          {
            path: "lmn-lookup",
            handle: { breadcrumb: "LMN lookup" },
            async lazy() {
              const { HsaLmnLookupPage } =
                await import("../conversion/hsa-lmn-lookup-page");
              return { Component: HsaLmnLookupPage };
            },
          },
          {
            path: "funnel-analytics",
            handle: { breadcrumb: "LMN Analytics" },
            children: [
              {
                index: true,
                async lazy() {
                  const { HsaFunnelAnalyticsPage } =
                    await import("../conversion/hsa-funnel-analytics-page");
                  return { Component: HsaFunnelAnalyticsPage };
                },
              },
              {
                path: ":teamId",
                handle: { breadcrumb: hsaFunnelMerchantBreadcrumb },
                async lazy() {
                  const { HsaFunnelMerchantPage } =
                    await import("../conversion/hsa-funnel-merchant-page");
                  return {
                    element: (
                      <HsaFunnelMerchantPage
                        breadcrumb={hsaFunnelMerchantBreadcrumb}
                      />
                    ),
                  };
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
